import styled from 'styled-components';

export const Adicionar = styled.button`
  border: none;
  background-color: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: 1rem;
`;
